import React, { useEffect, useState } from "react";
import UsePanel from "./UserPanel";
import SocialSource from "./SocialSource";
import OverView from "./OverView";
import { Row, Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { getDashboardAnalytics } from "../../apiServices/AnalyticsServices";

const Dashboard = () => {
  document.title = "Dashboard | RS-CRM";
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        setLoading(true);
        const res = await getDashboardAnalytics();
        setDashboardData(res?.data || null);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="RS CRM" breadcrumbItem="Dashboard" />

          <UsePanel dashboardData={dashboardData} loading={loading} />

          <Row className="mt-3">
            <OverView charts={dashboardData?.charts} loading={loading} />
            <SocialSource charts={dashboardData?.charts} loading={loading} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Dashboard;
